import {  Component, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'mps-app-footer',
  templateUrl: './mps-footer.component.html',
  styleUrls: ['./mps-footer.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MpsFooterComponent {
  currentYear = moment().format('Y');
}
